// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const notificationsClient = createTypedClient();
export const createNotificationsClient = (config) => createTypedClient(config);
